import { render, staticRenderFns } from "./GlossaryRegionsEdit.vue?vue&type=template&id=b96db952&"
import script from "./GlossaryRegionsEdit.vue?vue&type=script&lang=js&"
export * from "./GlossaryRegionsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports